/*
  KP: THE BUNDLE PAGES (one page per bundle, e.g. /pages/build-magnetic-bundle), where a
  shopper builds a bundle and can MIX DESIGNS: every item starts on the same design as
  their case (or, with no case, as the power bank), and each one can be switched to any
  other design. Made 13 Oct 2026; laid out like a phone case product page the same day
  (photos on the left, title and price, then the picker box with the green Add to Cart).

  The page is the section sections/kp-bundle-builder.liquid; which bundle it builds is
  chosen in that section's settings ("Bundle"). Styles: assets/kp-bundle-pages.css.

  THE BUNDLES are in BUNDLES below. What can be set on one:
    - name, short:  the bundle's name, and a short one for buttons ("Magnetic").
    - percent:      ONLY what is SHOWN. It must be the same as the Selleasy rule.
    - code, offer:  the discount's code exactly as in Shopify admin > Discounts, and
                    "offer#" + the first 8 characters of the Selleasy offer number. Same
                    as in assets/kp-bundles-config.js (the Bundles tab); read from
                    Shopify admin > Discounts on 12-13 Oct 2026.
    - page:         the page's web address name (/pages/...), for the "More bundles" links.
    - phone:        true when a phone case is in the bundle (so the phone model is asked).
    - caseType:     'M' (MagSafe tough), 'T', 'S', or 'choose' (the shopper picks).
    - fallback:     with caseType 'M': the case type used for phones that do not come in
                    MagSafe. Leave it out for bundles that need MagSafe (Essential,
                    Ultimate): those phones are told to pick another bundle.
    - items:        the other things in it, in order, by kind (see KINDS below), with:
                      variant: which version to use ('Power Bank & Shell'),
                      variantNoMagsafe: the version when the case is not MagSafe,
                      start: the version to start on when the shopper can choose.
    - itemsNoMagsafe: a different list for phones with no MagSafe case (Everyday swaps
                    the magnetic wallet for a water bottle, as on the Bundles tab).
    - build:        { min: 3, kinds: [...] } for BUILD YOUR OWN: the case plus any of
                    those kinds; the discount comes on at "min" items, case included.
    - anchor:       for a bundle with no case, the kind whose design the others match.

  HOW THE DISCOUNT GETS ON: as with the Bundles tab, each item is added with the hidden
  line property "_lb-product" = <first item's product number>#<offer>, and the code is
  put on the cart (keeping codes already there). The Selleasy rule counts the marked
  items, whatever their designs (tested in the cart on 13 Oct 2026: a Gone Fishing case,
  a Spaghetti Upsetti power bank and an Overstimulated Goose ring holder all got the
  Magnetic Bundle's 15%). If a code is renamed in Shopify, change it here too.
  CATCH: each Selleasy offer only gives its discount when the first item is in one of
  the offer's chosen collections (Phone Cases plus a few design collections, as set up
  on 13 Oct 2026). Bundles that start with a case are fine. On the Go and Fits Any Phone
  start with a power bank, so in Selleasy the Magnetic Power Bank collection must be
  added to those two offers, or most designs get no discount (tested 13 Oct 2026).

  KINDS: where each kind of item comes from (a collection's web address name, and the
  words its products' names must contain), and how it is shown.
*/
(function () {
  var API = '/api/2025-07/graphql.json';
  var STORE = 'kpCaseChoice';
  var PROPERTY = '_lb-product';
  var MONEY_TOKEN = /\{\{\s*(\w+)\s*\}\}/;
  var PAGE_SIZE = 24;

  var TYPE_NAMES = { T: 'Tough Case', S: 'Snap Case', M: 'Magsafe Tough Case' };
  var TYPE_LABELS = { T: 'Tough', S: 'Snap', M: 'MagSafe Tough' };
  // Pictures for the case type cards: set by the section (the theme's kp-case-*.jpg).
  var CASE_PICS = window.kpCaseTypePics || {};

  var KINDS = {
    case: { label: 'Phone case', step: 'Pick your case design', collection: 'phone-cases', has: /phone case/i, not: /clear|airpods|ipad/i },
    bank: { label: 'Power bank', step: 'Your power bank', collection: 'magnetic-power-bank', has: /power bank/i, variant: 'Power Bank & Shell' },
    ring: { label: 'Ring holder', step: 'Your ring holder', collection: 'magnetic-ring-holder', has: /ring holder/i, variant: 'Magnetic Ring Holder', variantNoMagsafe: 'Magnetic Ring Holder + Metal Mount' },
    wallet: { label: 'Wallet', step: 'Your wallet', collection: 'magnetic-wallets', has: /wallet/i },
    bottle: { label: 'Water bottle', step: 'Your water bottle', collection: 'stainless-steel-water-bottles', has: /bottle/i },
    airpods: { label: 'AirPods case', step: 'Your AirPods case', collection: 'airpods', has: /airpods/i, choose: 'Which AirPods?' },
    ipad: { label: 'iPad case', step: 'Your iPad case', collection: 'tablet-cases', has: /ipad|tablet/i, choose: 'Which iPad?' },
    strap: { label: 'Phone strap', step: 'Your phone strap', handle: 'phone-strap', choose: 'Which strap?', start: 'Black crossbody strap' }
  };

  var BUNDLES = {
    magnetic: {
      name: 'The Magnetic Bundle', short: 'Magnetic', percent: 15, code: 'MAGNETIC BUNDLE', offer: 'offer#8ebbde81', page: 'build-magnetic-bundle',
      phone: true, caseType: 'M', fallback: 'T',
      items: [{ kind: 'bank' }, { kind: 'ring' }]
    },
    everyday: {
      name: 'The Everyday Bundle', short: 'Everyday', percent: 15, code: 'EVERYDAYBUNDLE#f7fc', offer: 'offer#0cd72e80', page: 'build-everyday-bundle',
      phone: true, caseType: 'M', fallback: 'T',
      items: [{ kind: 'strap', start: 'Black crossbody strap' }, { kind: 'wallet' }],
      itemsNoMagsafe: [{ kind: 'strap', start: 'Black crossbody strap' }, { kind: 'bottle' }]
    },
    essential: {
      name: 'The Essential Bundle', short: 'Essential', percent: 15, code: 'EssentialBUNDLE#a603', offer: 'offer#09150fcf', page: 'build-essential-bundle',
      phone: true, caseType: 'M',
      items: [{ kind: 'bank' }]
    },
    ultimate: {
      name: 'The Ultimate Bundle', short: 'Ultimate', percent: 20, code: 'ULTIMATE#6c1c', offer: 'offer#d3bc94b9', page: 'build-ultimate-bundle',
      phone: true, caseType: 'M',
      items: [{ kind: 'bank' }, { kind: 'ring' }, { kind: 'wallet' }, { kind: 'strap', start: 'Black crossbody strap' }]
    },
    sip: {
      name: 'The Sip & Scroll Bundle', short: 'Sip & Scroll', percent: 10, code: 'Sip&Scroll#5e55', offer: 'offer#ac7b60fe', page: 'build-sip-and-scroll-bundle',
      phone: true, caseType: 'choose',
      items: [{ kind: 'bottle' }]
    },
    onthego: {
      name: 'The On the Go Bundle', short: 'On the Go', percent: 15, code: 'onthego#babc', offer: 'offer#31da9238', page: 'build-on-the-go-bundle', hidden: true,
      phone: false, anchor: 'bank',
      items: [{ kind: 'bank' }, { kind: 'bottle' }]
    },
    anyphone: {
      name: 'The Fits Any Phone Bundle', short: 'Fits Any Phone', percent: 15, code: 'anyphone#f6a6', offer: 'offer#2747b879', page: 'build-fits-any-phone-bundle', hidden: true,
      phone: false, anchor: 'bank',
      items: [{ kind: 'bank' }, { kind: 'ring', variant: 'Magnetic Ring Holder + Metal Mount' }, { kind: 'strap', start: 'Black wrist strap' }]
    },
    build: {
      name: 'Build Your Own Bundle', short: 'Build your own', percent: 15, code: 'BUILD A BUNDLE#bb60', offer: 'offer#d10413f1', page: 'build-your-own-bundle',
      phone: true, caseType: 'choose',
      build: { min: 3, kinds: ['bank', 'ring', 'wallet', 'bottle', 'airpods', 'ipad', 'strap'] }
    }
  };
  window.KP_BUNDLE_PAGES = BUNDLES;

  // ---------------------------------------------------------------- helpers

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined && text !== null) node.textContent = text;
    return node;
  }

  function withSeparators(value, decimals, thousands, decimal) {
    var parts = value.toFixed(decimals).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts.join(decimal);
  }

  function money(amount) {
    var format = (window.theme && window.theme.moneyFormat) || '£{{amount}}';
    var value = parseFloat(amount);
    if (isNaN(value) || !MONEY_TOKEN.test(format)) return '';
    return format.replace(MONEY_TOKEN, function (match, type) {
      switch (type) {
        case 'amount_no_decimals': return withSeparators(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withSeparators(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withSeparators(value, 0, '.', ',');
        default: return withSeparators(value, 2, ',', '.');
      }
    }).replace(/<[^>]+>/g, '');
  }

  function pence(amount) {
    return Math.round(parseFloat(amount) * 100);
  }

  // The price after the discount, as the checkout works it out (the discount rounded down).
  function reducedPence(amount, percent) {
    var p = pence(amount);
    return p - Math.floor(p * percent / 100);
  }

  // "Power bank" -> "power bank", but "AirPods case" and "iPad case" stay as they are.
  function lower(label) {
    return /^(AirPods|iPad)/.test(label) ? label : label.charAt(0).toLowerCase() + label.slice(1);
  }

  function numberOf(gid) {
    return String(gid).split('/').pop();
  }

  function ask(query, variables) {
    variables = variables || {};
    variables.c = (window.Shopify && window.Shopify.country) || null;
    return fetch(API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ query: query, variables: variables })
    }).then(function (r) { return r.json(); }).then(function (j) { return (j && j.data) || null; }).catch(function () { return null; });
  }

  // The design's name: the product name without what kind of thing it is.
  var KIND_WORDS = /\b(tough magsafe|magsafe tough|magnetic power bank|power bank|magnetic ring holder|ring holder|magnetic wallet|wallet|stainless steel water bottle|water bottle|airpods case|airpods|ipad case|tablet case|wavy|snap|tough|magsafe|phone case|case)\b/gi;

  function designName(title) {
    var name = String(title).replace(KIND_WORDS, ' ').replace(/\s+/g, ' ').trim();
    return name || title;
  }

  function designKey(title) {
    return designName(title).toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  }

  // The phone to start on: the variant match one (the phone case in the cart, or the
  // model chosen on a collection page, whichever is newer; see assets/kp-variant-match.js),
  // else the model chosen earlier in this visit.
  function remembered() {
    if (window.kpVariantMatch && window.kpVariantMatch.get()) return window.kpVariantMatch.get();
    try {
      var saved = JSON.parse(window.sessionStorage.getItem(STORE) || 'null');
      return saved && saved.model ? saved.model : '';
    } catch (e) { return ''; }
  }

  function remember(model) {
    try {
      var saved = JSON.parse(window.sessionStorage.getItem(STORE) || 'null') || {};
      window.sessionStorage.setItem(STORE, JSON.stringify({ model: model, kase: saved.kase || '', t: Date.now() }));
    } catch (e) {}
  }

  // ---------------------------------------------------------------- data

  var lists = {};

  // Every product of a kind (all designs), from its collection.
  function loadList(kind) {
    if (lists[kind]) return lists[kind];
    var spec = KINDS[kind];

    if (spec.handle) {
      lists[kind] = ask('query ($h: String!, $c: CountryCode) @inContext(country: $c) { p: product(handle: $h) { id handle title availableForSale featuredImage { url(transform: { maxWidth: 360 }) } big: featuredImage { url(transform: { maxWidth: 900 }) } } }', { h: spec.handle })
        .then(function (data) { return data && data.p ? [data.p] : []; });
      return lists[kind];
    }

    var all = [];
    var page = function (after) {
      return ask('query ($h: String!, $a: String, $c: CountryCode) @inContext(country: $c) { col: collection(handle: $h) { products(first: 250, after: $a, sortKey: BEST_SELLING) { pageInfo { hasNextPage endCursor } nodes { id handle title availableForSale featuredImage { url(transform: { maxWidth: 360 }) } big: featuredImage { url(transform: { maxWidth: 900 }) } } } } }', { h: spec.collection, a: after || null })
        .then(function (data) {
          var block = data && data.col && data.col.products;
          if (!block) return all;
          block.nodes.forEach(function (p) {
            if (!p.availableForSale) return;
            if (spec.has && !spec.has.test(p.title)) return;
            if (spec.not && spec.not.test(p.title)) return;
            all.push(p);
          });
          return block.pageInfo.hasNextPage && all.length < 1200 ? page(block.pageInfo.endCursor) : all;
        });
    };

    lists[kind] = page(null);
    return lists[kind];
  }

  var variantCache = {};

  // A product's versions (not for phone cases: those have hundreds; see caseVariant).
  function loadVariants(handle) {
    if (variantCache[handle]) return variantCache[handle];
    variantCache[handle] = ask('query ($h: String!, $c: CountryCode) @inContext(country: $c) { p: product(handle: $h) { id variants(first: 100) { nodes { id title availableForSale price { amount } image { url(transform: { maxWidth: 900 }) } } } } }', { h: handle })
      .then(function (data) { return data && data.p ? data.p.variants.nodes : []; });
    return variantCache[handle];
  }

  var caseCache = {};

  function caseVariant(handle, model, typeName) {
    var key = handle + '|' + model + '|' + typeName;
    if (caseCache[key]) return caseCache[key];
    caseCache[key] = ask('query ($h: String!, $m: String!, $t: String!, $c: CountryCode) @inContext(country: $c) { p: product(handle: $h) { v: variantBySelectedOptions(selectedOptions: [{ name: "Model", value: $m }, { name: "Case Type", value: $t }]) { id title availableForSale price { amount } image { url(transform: { maxWidth: 900 }) } } } }', { h: handle, m: model, t: typeName })
      .then(function (data) { return data && data.p ? data.p.v : null; });
    return caseCache[key];
  }

  // The case design tiles show the case on the shopper's phone. Fetched in batches of
  // 25 (one request each) for the tiles on show, then kept: handle|model|type -> url.
  var tilePics = {};
  var tileAsked = {};

  function loadTilePics(handles, model, typeName) {
    var todo = handles.filter(function (h) { return !tileAsked[h + '|' + model + '|' + typeName]; }).slice(0, 25);
    if (!todo.length) return Promise.resolve(false);
    todo.forEach(function (h) { tileAsked[h + '|' + model + '|' + typeName] = true; });
    var parts = todo.map(function (h, i) {
      return 'p' + i + ': product(handle: ' + JSON.stringify(h) + ') { v: variantBySelectedOptions(selectedOptions: [{ name: "Model", value: $m }, { name: "Case Type", value: $t }]) { image { url(transform: { maxWidth: 360 }) } } }';
    });
    return ask('query ($m: String!, $t: String!, $c: CountryCode) @inContext(country: $c) { ' + parts.join(' ') + ' }', { m: model, t: typeName }).then(function (data) {
      todo.forEach(function (h, i) {
        var p = data && data['p' + i];
        var url = p && p.v && p.v.image && p.v.image.url;
        if (url) tilePics[h + '|' + model + '|' + typeName] = url;
      });
      return true;
    });
  }

  // Every product in one design, found by its name in one quick request (all kinds at
  // once: case, power bank, ring holder...), with their versions and prices, so the
  // matching items show without waiting for the full lists.
  var designCache = {};

  function loadDesign(name) {
    if (designCache[name]) return designCache[name];
    designCache[name] = ask('query ($q: String!, $c: CountryCode) @inContext(country: $c) { products(first: 30, query: $q) { nodes { id handle title availableForSale featuredImage { url(transform: { maxWidth: 360 }) } big: featuredImage { url(transform: { maxWidth: 900 }) } variants(first: 40) { pageInfo { hasNextPage } nodes { id title availableForSale price { amount } image { url(transform: { maxWidth: 900 }) } } } } } }', { q: 'title:' + JSON.stringify(name) })
      .then(function (data) {
        var nodes = (data && data.products && data.products.nodes) || [];
        nodes.forEach(function (p) {
          if (p.variants && !p.variants.pageInfo.hasNextPage && !variantCache[p.handle]) variantCache[p.handle] = Promise.resolve(p.variants.nodes);
        });
        return nodes;
      });
    return designCache[name];
  }

  var recCache = {};

  // The products that match a design (Search & Discovery's complementary products).
  function loadMatches(handle) {
    if (recCache[handle]) return recCache[handle];
    recCache[handle] = ask('query ($h: String!, $c: CountryCode) @inContext(country: $c) { r: productRecommendations(productHandle: $h, intent: COMPLEMENTARY) { handle title } }', { h: handle })
      .then(function (data) { return (data && data.r) || []; });
    return recCache[handle];
  }

  // ---------------------------------------------------------------- the builder

  function start(root) {
    if (root.kpReady) return;
    var bundle = BUNDLES[root.getAttribute('data-bundle')];
    if (!bundle) return;
    root.kpReady = true;

    var models = [];
    var byModel = {};
    (window.kpCaseModels || []).forEach(function (row) {
      row[2].split(',').forEach(function (part) {
        var item = { name: row[1] + part, types: row[0] };
        models.push(item);
        byModel[item.name] = item;
      });
    });

    var GROUPS = [['iPhone', 'iPhone'], ['Galaxy', 'Samsung'], ['Pixel', 'Google Pixel'], ['Xiaomi', 'Xiaomi'], ['Oneplus', 'OnePlus'], [null, 'Other']];
    function groupOf(name) {
      for (var i = 0; i < GROUPS.length; i++) if (GROUPS[i][0] === null || name.indexOf(GROUPS[i][0]) > -1) return GROUPS[i][1];
      return 'Other';
    }

    var startModel = remembered();
    var state = {
      model: byModel[startModel] ? startModel : '',
      chosenType: bundle.caseType === 'choose' ? 'T' : '',
      extras: [],          // build your own: the kinds ticked
      slots: {},           // key -> { kind, product, variant, variants, own (chosen by hand), open, shown, query }
      busy: false
    };

    // ---- What the bundle holds for the phone chosen ----

    function magsafeOk() {
      return !!(state.model && byModel[state.model] && byModel[state.model].types.indexOf('M') > -1);
    }

    function typeCode() {
      if (!bundle.phone) return '';
      if (bundle.caseType === 'choose') {
        var t = state.chosenType;
        if (state.model && byModel[state.model] && byModel[state.model].types.indexOf(t) < 0) t = 'T';
        return t;
      }
      if (bundle.caseType === 'M') {
        if (!state.model || magsafeOk()) return 'M';
        return bundle.fallback || '';
      }
      return bundle.caseType;
    }

    function blockedPhone() {
      return bundle.phone && bundle.caseType === 'M' && !bundle.fallback && state.model && !magsafeOk();
    }

    function itemList() {
      if (bundle.build) return state.extras.map(function (kind) { return { kind: kind }; });
      if (state.model && !magsafeOk() && bundle.itemsNoMagsafe) return bundle.itemsNoMagsafe;
      return bundle.items;
    }

    // The slots, in order: the case (if any), then the items. Each item kind once, so the
    // key is the kind (a bundle never has two of one kind).
    function slotList() {
      var out = [];
      if (bundle.phone) out.push({ key: 'case', kind: 'case' });
      itemList().forEach(function (item) { out.push({ key: item.kind, kind: item.kind, item: item }); });
      return out;
    }

    function slot(key, kind) {
      if (!state.slots[key]) state.slots[key] = { kind: kind, product: null, variant: null, variants: null, own: false, open: false, shown: PAGE_SIZE, query: '' };
      return state.slots[key];
    }

    // The anchor: the slot whose design the others start on.
    function anchorKey() {
      return bundle.phone ? 'case' : bundle.anchor;
    }

    function wantedVariant(entry) {
      var kind = KINDS[entry.kind];
      var item = entry.item || {};
      var magsafe = bundle.phone ? typeCode() === 'M' : false;
      if (item.variant) return item.variant;
      if (bundle.phone && !magsafe && (item.variantNoMagsafe || kind.variantNoMagsafe)) return item.variantNoMagsafe || kind.variantNoMagsafe;
      return kind.variant || item.start || kind.start || '';
    }

    // ---- Choosing ----

    function setProduct(entry, product, own) {
      var s = slot(entry.key, entry.kind);
      s.product = product;
      s.variant = null;
      s.variants = null;
      if (own) s.own = true;
      return resolve(entry);
    }

    // Find the version of the chosen product: for a case, in the chosen model and case
    // type; for anything else, the version the bundle asks for (or the first one).
    function resolve(entry) {
      var s = slot(entry.key, entry.kind);
      if (!s.product) return Promise.resolve();

      if (entry.kind === 'case') {
        var product = s.product;
        if (!state.model) {
          // No phone yet: show the case's photo and price from a phone it comes for,
          // so the page looks like a product page. It is never added like this.
          s.variant = null;
          var code = typeCode() || 'T';
          var sample = models.filter(function (m) { return m.types.indexOf(code) > -1; })[0];
          if (!sample) return Promise.resolve();
          return caseVariant(product.handle, sample.name, TYPE_NAMES[code]).then(function (v) {
            if (s.product === product && !state.model) s.preview = v || null;
          });
        }
        s.preview = null;
        return caseVariant(product.handle, state.model, TYPE_NAMES[typeCode()] || 'Tough Case').then(function (v) {
          if (s.product !== product) return;
          s.variant = v && v.availableForSale ? v : null;
          s.missing = !s.variant;
        });
      }

      var p = s.product;
      return loadVariants(p.handle).then(function (variants) {
        if (s.product !== p) return;
        var ok = variants.filter(function (v) { return v.availableForSale; });
        s.variants = ok;
        var want = wantedVariant(entry);
        // A version the shopper picked themselves (AirPods model, strap) is kept.
        var keep = KINDS[entry.kind].choose && s.variant && ok.filter(function (v) { return v.id === s.variant.id; })[0];
        s.variant = keep || ok.filter(function (v) { return want && v.title === want; })[0] || ok[0] || null;
        s.missing = !s.variant;
      });
    }

    // Every item not chosen by hand starts on the anchor's design.
    function matchAll() {
      var aKey = anchorKey();
      var anchor = state.slots[aKey];
      if (!anchor || !anchor.product) return Promise.resolve();
      var aKey2 = designKey(anchor.product.title);

      // Fast first: the product with the same design name. Only when there is none is
      // Shopify's (slow, about a second) list of matching products asked.
      var jobs = slotList().filter(function (entry) { return entry.key !== aKey; }).map(function (entry) {
        var s = slot(entry.key, entry.kind);
        var spec = KINDS[entry.kind];
        if (s.own && s.product) return resolve(entry);
        if (spec.handle) return s.product ? resolve(entry) : loadList(entry.kind).then(function (list) { return list[0] ? setProduct(entry, list[0], false) : null; });

        if (!s.product) s.pending = true;
        return loadDesign(designName(anchor.product.title)).then(function (same) {
          var quick = same.filter(function (p) {
            return p.availableForSale && spec.has.test(p.title) && !(spec.not && spec.not.test(p.title)) && designKey(p.title) === aKey2;
          })[0];
          if (state.slots[aKey] !== anchor || designKey(anchor.product.title) !== aKey2) { s.pending = false; return null; }
          if (quick) { s.pending = false; s.matched = true; return setProduct(entry, quick, false); }
          return loadList(entry.kind);
        }).then(function (list) {
          if (!list || !list.filter) return null;
          var found = list.filter(function (p) { return designKey(p.title) === aKey2; })[0];
          if (found) { s.pending = false; s.matched = true; return setProduct(entry, found, false); }
          return loadMatches(anchor.product.handle).then(function (recs) {
            s.pending = false;
            if (state.slots[aKey] !== anchor || designKey(anchor.product.title) !== aKey2) return null;
            var rec = recs.filter(function (r) { return spec.has.test(r.title); })[0];
            var hit = rec && list.filter(function (p) { return p.handle === rec.handle; })[0];
            s.matched = !!hit;
            if (hit) return setProduct(entry, hit, false);
            if (!s.product) { s.open = true; return null; }
            return resolve(entry);
          });
        });
      });
      return Promise.all(jobs);
    }

    function refresh(keep) {
      var jobs = slotList().map(function (entry) { return resolve(entry); });
      return Promise.all(jobs).then(function () { draw(keep); });
    }

    // ---- Drawing: laid out like a phone case product page ----
    // The section gives three places: the photos (data-kp-bp-gallery), the price
    // (data-kp-bp-price) and the outlined box with the pickers and Add to Cart
    // (data-kp-bp-box). Everything is drawn into those.

    var page = root.closest('[data-kp-bp]') || document;
    var galleryEl = page.querySelector('[data-kp-bp-gallery]') || el('div');
    var priceEl = page.querySelector('[data-kp-bp-price]') || el('div');
    var box = root;
    var listMap = {};
    var view = { slide: 0, follow: '' };

    function lineImage(s) {
      var v = s.variant;
      // The seed photo (already on the page) stays until a phone's own case photo is known.
      if (s.product && s.product.big && s.product.big.seed && !(s.kind === 'case' && v)) return s.product.big.url;
      return (v && v.image && v.image.url) || (s.product && s.product.big && s.product.big.url) || (s.preview && s.preview.image && s.preview.image.url) || (s.product && s.product.featuredImage && s.product.featuredImage.url) || '';
    }

    // The version whose price is shown (before a phone is chosen, the case's preview).
    function priced(s) {
      return s.variant || s.preview || null;
    }

    // The picture of a case design on the phone chosen (or '' until it is loaded).
    function tilePic(handle) {
      if (!state.model) return '';
      return tilePics[handle + '|' + state.model + '|' + (TYPE_NAMES[typeCode()] || 'Tough Case')] || '';
    }

    // Swap the case tiles on show to pictures of the chosen phone, a batch at a time.
    function fillTiles() {
      if (!state.model) return;
      var model = state.model;
      var typeName = TYPE_NAMES[typeCode()] || 'Tough Case';
      var tiles = Array.prototype.filter.call(box.querySelectorAll('[data-kp-bb-pick="case"]'), function (t) { return !t.hidden; });
      var handles = tiles.map(function (t) { return t.getAttribute('data-handle'); });
      loadTilePics(handles, model, typeName).then(function (more) {
        if (model !== state.model) return;
        Array.prototype.forEach.call(box.querySelectorAll('[data-kp-bb-pick="case"]'), function (t) {
          var url = tilePic(t.getAttribute('data-handle'));
          var img = t.querySelector('img');
          if (url && img && img.src !== url) img.src = url;
        });
        if (more) fillTiles();
      });
    }

    function label(text) {
      return el('div', 'kp-bp__label', text);
    }

    // The photos: one slide per item, swiped sideways (dots under them), with small
    // photos under the big one on larger screens. Empty slides show what still has to
    // be chosen.
    var gallerySig = '';
    function drawGallery() {
      var all = lines();
      var sig = all.map(function (line) { return lineImage(line.s) + '|' + line.entry.kind; }).join(',');
      if (sig === gallerySig && galleryEl.querySelector('.kp-bp__track')) {
        if (galleryEl.querySelector('.kp-bp__track').scrollLeft !== galleryEl.querySelector('.kp-bp__track').clientWidth * view.slide) showSlide(view.slide, true);
        return;
      }
      gallerySig = sig;
      galleryEl.innerHTML = '';

      var badge = el('span', 'kp-bp__badge', 'Save ' + bundle.percent + '% together');
      galleryEl.appendChild(badge);

      var track = el('div', 'kp-bp__track');
      all.forEach(function (line, i) {
        var slide = el('div', 'kp-bp__slide');
        slide.setAttribute('data-kp-bp-slide', String(i));
        var src = lineImage(line.s);
        if (src) {
          var img = el('img');
          img.src = src;
          img.alt = line.s.product ? line.s.product.title : '';
          img.width = 900;
          img.height = 900;
          img.loading = i ? 'lazy' : 'eager';
          slide.appendChild(img);
        } else {
          slide.appendChild(el('span', 'kp-bp__slide-empty', 'Choose your ' + lower(KINDS[line.entry.kind].label)));
        }
        slide.appendChild(el('span', 'kp-bp__slide-tag', KINDS[line.entry.kind].label));
        track.appendChild(slide);
      });
      galleryEl.appendChild(track);

      if (all.length > 1) {
        var dots = el('div', 'kp-bp__dots');
        var thumbs = el('div', 'kp-bp__thumbs');
        all.forEach(function (line, i) {
          var dot = el('button', 'kp-bp__dot' + (i === view.slide ? ' is-on' : ''));
          dot.type = 'button';
          dot.setAttribute('aria-label', 'Photo ' + (i + 1));
          dot.setAttribute('data-kp-bp-go', String(i));
          dots.appendChild(dot);

          var t = el('button', 'kp-bp__thumb' + (i === view.slide ? ' is-on' : ''));
          t.type = 'button';
          t.setAttribute('aria-label', KINDS[line.entry.kind].label);
          t.setAttribute('data-kp-bp-go', String(i));
          var src = lineImage(line.s);
          if (src) {
            var img = el('img');
            img.src = src;
            img.alt = '';
            img.width = 80;
            img.height = 80;
            t.appendChild(img);
          }
          thumbs.appendChild(t);
        });
        galleryEl.appendChild(dots);
        galleryEl.appendChild(thumbs);
      }

      track.addEventListener('scroll', function () {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i === view.slide) return;
        view.slide = i;
        Array.prototype.forEach.call(galleryEl.querySelectorAll('[data-kp-bp-go]'), function (b) {
          b.classList.toggle('is-on', b.getAttribute('data-kp-bp-go') === String(i));
        });
      }, { passive: true });

      if (view.slide) track.scrollLeft = track.clientWidth * view.slide;
    }

    function showSlide(i, smooth) {
      var track = galleryEl.querySelector('.kp-bp__track');
      if (!track) return;
      view.slide = i;
      track.scrollTo({ left: track.clientWidth * i, behavior: smooth ? 'smooth' : 'auto' });
      Array.prototype.forEach.call(galleryEl.querySelectorAll('[data-kp-bp-go]'), function (b) {
        b.classList.toggle('is-on', b.getAttribute('data-kp-bp-go') === String(i));
      });
    }

    // The price, as on a product page: the bundle price, the full price struck through,
    // and the saving.
    function drawPrice() {
      var all = lines();
      var was = 0;
      var now = 0;
      var complete = true;
      all.forEach(function (line) {
        var v = priced(line.s);
        if (!v) { complete = false; return; }
        was += pence(v.price.amount);
        now += reducedPence(v.price.amount, activePercent());
      });
      priceEl.innerHTML = '';
      if (!was) {
        priceEl.appendChild(el('span', 'kp-bp__price-now', 'Save ' + bundle.percent + '% when bought together'));
        return;
      }
      priceEl.appendChild(el('span', 'kp-bp__price-now', money(now / 100)));
      if (now < was) {
        priceEl.appendChild(el('s', 'kp-bp__price-was', money(was / 100)));
        priceEl.appendChild(el('span', 'kp-bp__price-save', 'Save ' + money((was - now) / 100)));
      }
      if (!complete) priceEl.appendChild(el('span', 'kp-bp__price-note', 'so far'));
    }

    // "Select your phone": the model dropdown, then the case type cards (when the bundle
    // lets the shopper choose), then any note about MagSafe.
    function phoneRows() {
      var rows = [];
      var row = el('div', 'kp-bp__row');
      row.setAttribute('data-kp-bb-step', 'phone');
      row.appendChild(label('Select your phone'));
      var select = el('select', 'kp-bp__select');
      select.setAttribute('aria-label', 'Your phone model');
      select.setAttribute('data-kp-bb-model', '');
      var first = el('option', '', 'Select your phone model');
      first.value = '';
      select.appendChild(first);
      GROUPS.forEach(function (g) {
        var og = el('optgroup');
        og.label = g[1];
        models.forEach(function (m) {
          if (groupOf(m.name) !== g[1]) return;
          var o = el('option', '', m.name);
          o.value = m.name;
          if (m.name === state.model) o.selected = true;
          og.appendChild(o);
        });
        if (og.children.length) select.appendChild(og);
      });
      row.appendChild(select);
      rows.push(row);

      if (bundle.caseType === 'choose') {
        var crow = el('div', 'kp-bp__row');
        crow.setAttribute('data-kp-bb-step', 'type');
        crow.appendChild(label('Choose your case'));
        var cards = el('div', 'kp-bp__cards');
        ['S', 'T', 'M'].forEach(function (code) {
          var possible = !state.model || byModel[state.model].types.indexOf(code) > -1;
          if (!possible) return;
          var on = typeCode() === code;
          var card = el('button', 'kp-bp__card' + (on ? ' is-selected' : ''));
          card.type = 'button';
          card.setAttribute('aria-pressed', on ? 'true' : 'false');
          card.setAttribute('data-kp-bb-type', code);
          var pic = el('span', 'kp-bp__card-image');
          if (CASE_PICS[code]) pic.style.backgroundImage = 'url("' + CASE_PICS[code] + '")';
          card.appendChild(pic);
          if (code === 'T') card.appendChild(el('span', 'kp-bp__card-badge', 'Most popular'));
          card.appendChild(el('span', 'kp-bp__card-name', TYPE_NAMES[code]));
          cards.appendChild(card);
        });
        crow.appendChild(cards);
        rows.push(crow);
      } else if (bundle.caseType === 'M' && (!state.model || magsafeOk())) {
        rows.push(el('p', 'kp-bp__hint', 'Comes with a MagSafe Tough Case, so everything snaps on.'));
      }

      if (blockedPhone()) {
        var note = el('p', 'kp-bp__note kp-bp__note--stop');
        note.appendChild(document.createTextNode(state.model + ' doesn’t come in a MagSafe case, and this bundle is all magnetic. '));
        var alt = el('a', '', 'Try the Magnetic Bundle instead');
        alt.href = '/pages/' + BUNDLES.magnetic.page;
        note.appendChild(alt);
        note.appendChild(document.createTextNode(', which works with any phone.'));
        rows.push(note);
      } else if (state.model && bundle.caseType === 'M' && !magsafeOk()) {
        rows.push(el('p', 'kp-bp__note', state.model + ' doesn’t come in MagSafe, so your bundle comes with a Tough Case' + (bundle.items.some(function (i) { return i.kind === 'ring'; }) ? ' and a ring holder with a metal mount that sticks to any phone.' : (bundle.itemsNoMagsafe ? ' and a water bottle instead of the magnetic wallet.' : '.'))));
      }
      return rows;
    }

    // One design tile in a picker's grid.
    function tile(entry, product, s, anchorDesign) {
      var on = s.product && s.product.handle === product.handle;
      var b = el('button', 'kp-bp__tile' + (on ? ' is-selected' : ''));
      b.type = 'button';
      b.setAttribute('data-kp-bb-pick', entry.key);
      b.setAttribute('data-handle', product.handle);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('data-name', designName(product.title).toLowerCase());
      var pic = el('span', 'kp-bp__tile-image');
      var own = entry.kind === 'case' ? tilePic(product.handle) : '';
      if (own || product.featuredImage) {
        var img = el('img');
        img.src = own || product.featuredImage.url;
        img.alt = '';
        img.loading = 'lazy';
        img.width = 180;
        img.height = 180;
        pic.appendChild(img);
      }
      b.appendChild(pic);
      if (anchorDesign && designKey(product.title) === anchorDesign) b.appendChild(el('span', 'kp-bp__tile-badge', 'Matches'));
      b.appendChild(el('span', 'kp-bp__tile-name', designName(product.title)));
      return b;
    }

    function grid(entry, s, list) {
      var wrap = el('div', 'kp-bp__panel');
      if (list.length > 12) {
        var search = el('input', 'kp-bp__search');
        search.type = 'search';
        search.placeholder = 'Search designs';
        search.setAttribute('aria-label', 'Search designs');
        search.setAttribute('data-kp-bb-search', entry.key);
        search.value = s.query || '';
        wrap.appendChild(search);
      }
      var g = el('div', 'kp-bp__grid');
      var anchor = state.slots[anchorKey()];
      var anchorDesign = entry.key !== anchorKey() && anchor && anchor.product ? designKey(anchor.product.title) : '';
      // The chosen design and the matching one come first.
      var sorted = list.slice().sort(function (a, b) {
        var sa = (s.product && a.handle === s.product.handle ? 2 : 0) + (anchorDesign && designKey(a.title) === anchorDesign ? 1 : 0);
        var sb = (s.product && b.handle === s.product.handle ? 2 : 0) + (anchorDesign && designKey(b.title) === anchorDesign ? 1 : 0);
        return sb - sa;
      });
      var q = (s.query || '').toLowerCase().trim();
      var count = 0;
      sorted.forEach(function (p) {
        var t = tile(entry, p, s, anchorDesign);
        var hit = !q || designName(p.title).toLowerCase().indexOf(q) > -1;
        if (!hit || (!q && count >= s.shown)) t.hidden = true;
        if (hit) count++;
        g.appendChild(t);
      });
      wrap.appendChild(g);
      if (!q && list.length > s.shown) {
        var more = el('button', 'kp-bp__more', 'Show more designs (' + (list.length - s.shown) + ')');
        more.type = 'button';
        more.setAttribute('data-kp-bb-more', entry.key);
        wrap.appendChild(more);
      }
      return wrap;
    }

    // One item: its label, then a dropdown-style button showing the design chosen
    // (photo, name, price), which opens the grid of designs under it.
    function itemRow(entry) {
      var s = slot(entry.key, entry.kind);
      var kind = KINDS[entry.kind];
      var row = el('div', 'kp-bp__row');
      row.setAttribute('data-kp-bb-step', entry.key);
      var isAnchor = entry.key === anchorKey();
      var title = entry.kind === 'case' ? 'Case design' : kind.label + (kind.handle ? '' : ' design');
      row.appendChild(label(title));

      var anchor = state.slots[anchorKey()];
      if (!isAnchor && !kind.handle && !(anchor && anchor.product)) {
        row.appendChild(el('p', 'kp-bp__hint', 'Starts on the same design as your ' + lower(KINDS[isAnchor ? entry.kind : anchorKey() === 'case' ? 'case' : bundle.anchor].label) + '. You can change it.'));
        return row;
      }

      if (s.pending && !s.product) {
        row.appendChild(el('p', 'kp-bp__hint', 'Matching your design…'));
        return row;
      }

      // A fixed product (the strap) shows the same kind of button, with the version
      // chosen (e.g. "Black crossbody strap"); it opens the versions as picture tiles.
      if (s.product) {
        var button = el('button', 'kp-bp__choice');
        button.type = 'button';
        button.setAttribute('aria-expanded', s.open ? 'true' : 'false');
        button.setAttribute('data-kp-bb-open', entry.key);
        var pic = el('span', 'kp-bp__choice-image');
        var src = kind.handle && s.variant && s.variant.image ? s.variant.image.url : lineImage(s);
        if (src) {
          var img = el('img');
          img.src = src;
          img.alt = '';
          img.width = 44;
          img.height = 44;
          pic.appendChild(img);
        }
        button.appendChild(pic);
        var text = el('span', 'kp-bp__choice-text');
        var name = el('span', 'kp-bp__choice-name', kind.handle && s.variant ? s.variant.title : designName(s.product.title));
        if (!isAnchor && s.matched && !s.own) name.appendChild(el('span', 'kp-bp__tag', 'Matches'));
        text.appendChild(name);
        var detail = '';
        if (entry.kind === 'case') detail = (TYPE_NAMES[typeCode()] || '') + (state.model ? ' · ' + state.model : '');
        else if (kind.handle) detail = designName(s.product.title);
        else if (s.variant && s.variant.title && s.variant.title !== 'Default Title' && !kind.choose) detail = s.variant.title;
        if (detail) text.appendChild(el('span', 'kp-bp__choice-detail', detail));
        button.appendChild(text);
        var pv = priced(s);
        if (pv) {
          var price = el('span', 'kp-bp__choice-price');
          var nowP = reducedPence(pv.price.amount, activePercent());
          price.innerHTML = (nowP < pence(pv.price.amount) ? '<s>' + money(pv.price.amount) + '</s>' : '') + '<span>' + money(nowP / 100) + '</span>';
          button.appendChild(price);
        }
        row.appendChild(button);
      }

      if (kind.choose && !kind.handle && s.variants && s.variants.length > 1) {
        var vs = el('select', 'kp-bp__select');
        vs.setAttribute('aria-label', kind.choose);
        vs.setAttribute('data-kp-bb-variant', entry.key);
        s.variants.forEach(function (v) {
          var o = el('option', '', v.title + (kind.handle ? ' · ' + money(reducedPence(v.price.amount, activePercent()) / 100) : ''));
          o.value = v.id;
          if (s.variant && v.id === s.variant.id) o.selected = true;
          vs.appendChild(o);
        });
        if (kind.handle && s.product) row.appendChild(el('div', 'kp-bp__fixed-name', designName(s.product.title)));
        row.appendChild(vs);
      }

      if (s.missing && entry.kind === 'case' && state.model) row.appendChild(el('p', 'kp-bp__note', 'This design isn’t made for ' + state.model + ' in this case type. Please pick another.'));
      if (!s.product && !isAnchor && !kind.handle) row.appendChild(el('p', 'kp-bp__hint', 'No matching ' + lower(kind.label) + ' for this design. Pick any you like.'));

      if (kind.handle && s.open && s.variants && s.variants.length) {
        var vwrap = el('div', 'kp-bp__panel');
        var vg = el('div', 'kp-bp__grid');
        s.variants.forEach(function (v) {
          var on = s.variant && s.variant.id === v.id;
          var vb = el('button', 'kp-bp__tile' + (on ? ' is-selected' : ''));
          vb.type = 'button';
          vb.setAttribute('data-kp-bb-version', entry.key);
          vb.setAttribute('data-id', v.id);
          vb.setAttribute('aria-pressed', on ? 'true' : 'false');
          var vp = el('span', 'kp-bp__tile-image');
          if (v.image) {
            var vi = el('img');
            vi.src = v.image.url;
            vi.alt = '';
            vi.loading = 'lazy';
            vi.width = 180;
            vi.height = 180;
            vp.appendChild(vi);
          }
          vb.appendChild(vp);
          vb.appendChild(el('span', 'kp-bp__tile-name', v.title));
          vg.appendChild(vb);
        });
        vwrap.appendChild(vg);
        row.appendChild(vwrap);
      }

      if ((s.open || !s.product) && !kind.handle) {
        var list = listMap[entry.kind];
        row.appendChild(list ? grid(entry, s, list) : el('p', 'kp-bp__hint', 'Loading designs…'));
      }
      return row;
    }

    function extrasRow() {
      var row = el('div', 'kp-bp__row');
      row.setAttribute('data-kp-bb-step', 'extras');
      var min = bundle.build.min;
      var need = Math.max(0, min - 1 - state.extras.length);
      row.appendChild(label('Add to your bundle'));
      row.appendChild(el('p', 'kp-bp__hint', need ? 'Pick ' + need + ' more to get ' + bundle.percent + '% off everything.' : bundle.percent + '% off everything in your bundle.'));
      var pills = el('div', 'kp-bp__pills');
      bundle.build.kinds.forEach(function (kind) {
        var on = state.extras.indexOf(kind) > -1;
        var pill = el('button', 'kp-bp__pill' + (on ? ' is-selected' : ''), (on ? '✓ ' : '+ ') + KINDS[kind].label);
        pill.type = 'button';
        pill.setAttribute('aria-pressed', on ? 'true' : 'false');
        pill.setAttribute('data-kp-bb-extra', kind);
        pills.appendChild(pill);
      });
      row.appendChild(pills);
      return row;
    }

    // What is in the bundle now, ready to add (or why not).
    function lines() {
      return slotList().map(function (entry) { return { entry: entry, s: slot(entry.key, entry.kind) }; });
    }

    function ready() {
      if (bundle.phone && !state.model) return 'Select your phone';
      if (blockedPhone()) return 'Pick another bundle';
      var all = lines();
      for (var i = 0; i < all.length; i++) {
        if (!all[i].s.product) return 'Choose your ' + lower(KINDS[all[i].entry.kind].label);
        if (!all[i].s.variant) return all[i].entry.kind === 'case' ? 'Pick another case design' : 'Choose your ' + lower(KINDS[all[i].entry.kind].label);
      }
      if (bundle.build && all.length < bundle.build.min) return 'Add ' + (bundle.build.min - all.length) + ' more to your bundle';
      return '';
    }

    function activePercent() {
      if (bundle.build && lines().length < bundle.build.min) return 0;
      return bundle.percent;
    }

    function buyRows() {
      var rows = [];
      if (bundle.phone) {
        var check = el('p', 'kp-bp__check');
        check.innerHTML = 'Double-check your <strong>phone model</strong> and <strong>case type</strong>.';
        rows.push(check);
      }
      var all = lines();
      var was = 0;
      var now = 0;
      all.forEach(function (line) {
        if (!line.s.variant) return;
        was += pence(line.s.variant.price.amount);
        now += reducedPence(line.s.variant.price.amount, activePercent());
      });
      var why = ready();
      var button = el('button', 'kp-bp__add' + (why ? ' is-blocked' : ''));
      button.type = 'button';
      button.setAttribute('data-kp-bb-add', '');
      if (why) button.setAttribute('aria-disabled', 'true');
      button.textContent = state.added ? '✓ Added to cart' : (state.busy ? 'Adding…' : (why || 'Add bundle to cart · ' + money(now / 100)));
      rows.push(button);
      if (!why && now < was) {
        var saving = el('p', 'kp-bp__saving');
        saving.innerHTML = 'You’re saving <strong>' + money((was - now) / 100) + '</strong> with this bundle';
        rows.push(saving);
      }
      return rows;
    }

    function drawBox() {
      var focused = document.activeElement && document.activeElement.getAttribute && document.activeElement.getAttribute('data-kp-bb-search');
      box.innerHTML = '';
      if (bundle.phone) phoneRows().forEach(function (r) { box.appendChild(r); });
      var entries = slotList();
      entries.forEach(function (entry, i) {
        if (bundle.build && i === 1) box.appendChild(extrasRow());
        box.appendChild(itemRow(entry));
      });
      if (bundle.build && entries.length === 1) box.appendChild(extrasRow());
      buyRows().forEach(function (r) { box.appendChild(r); });
      fillTiles();
      if (focused) {
        var again = box.querySelector('[data-kp-bb-search="' + focused + '"]');
        if (again) { again.focus(); try { again.setSelectionRange(again.value.length, again.value.length); } catch (e) {} }
      }
    }

    // Redraw without the page moving: the row named by "keep" (the one just tapped)
    // stays exactly where it was on screen; with no row named, the scroll stays put.
    function rowTop(key) {
      var r = key && box.querySelector('[data-kp-bb-step="' + key + '"]');
      return r ? r.getBoundingClientRect().top : null;
    }

    function draw(keep) {
      var y = window.scrollY;
      var before = rowTop(keep);
      drawBox();
      drawPrice();
      drawGallery();
      var after = rowTop(keep);
      if (before !== null && after !== null) window.scrollTo(0, window.scrollY + (after - before));
      else window.scrollTo(0, y);
    }

    // After a design is picked its grid closes. If the row's top is then above the
    // screen, bring it just into view (no smooth scrolling, so nothing slides about).
    function settle(key) {
      var top = rowTop(key);
      if (top !== null && top < 0) window.scrollTo(0, window.scrollY + top - 80);
    }

    function drawBar() {
      drawBox();
    }

    function loadLists() {
      var kinds = {};
      slotList().forEach(function (entry) { kinds[entry.kind] = true; });
      return Promise.all(Object.keys(kinds).map(function (kind) {
        if (listMap[kind]) return null;
        return loadList(kind).then(function (list) { listMap[kind] = list; });
      })).then(function () {
        // A fixed product (the strap) needs no design: put it in straight away.
        return Promise.all(slotList().map(function (entry) {
          var s = slot(entry.key, entry.kind);
          var list = listMap[entry.kind];
          if (KINDS[entry.kind].handle && !s.product && list && list[0]) return setProduct(entry, list[0], false);
          return null;
        }));
      });
    }

    function goTo(key) {
      var target = box.querySelector('[data-kp-bb-step="' + key + '"]');
      if (target && (target.getBoundingClientRect().top > window.innerHeight * 0.7 || target.getBoundingClientRect().top < 0)) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    function slideOf(key) {
      var keys = slotList().map(function (e) { return e.key; });
      return Math.max(0, keys.indexOf(key));
    }

    // ---- Events ----

    galleryEl.addEventListener('click', function (event) {
      var b = event.target.closest ? event.target.closest('[data-kp-bp-go]') : null;
      if (b) showSlide(parseInt(b.getAttribute('data-kp-bp-go'), 10), true);
    });

    box.addEventListener('change', function (event) {
      var t = event.target;
      if (t.hasAttribute('data-kp-bb-model')) {
        state.model = t.value;
        if (state.model) remember(state.model);
        loadLists().then(matchAll).then(function () { return refresh('phone'); });
        draw('phone');
        return;
      }
      if (t.hasAttribute('data-kp-bb-variant')) {
        var key = t.getAttribute('data-kp-bb-variant');
        var s = state.slots[key];
        if (s && s.variants) s.variant = s.variants.filter(function (v) { return v.id === t.value; })[0] || s.variant;
        view.slide = slideOf(key);
        draw(key);
      }
    });

    box.addEventListener('input', function (event) {
      var t = event.target;
      if (!t.hasAttribute('data-kp-bb-search')) return;
      var s = state.slots[t.getAttribute('data-kp-bb-search')];
      if (!s) return;
      s.query = t.value;
      // Filter the tiles in place, so typing is not interrupted.
      var q = t.value.toLowerCase().trim();
      var wrap = t.parentNode;
      var count = 0;
      Array.prototype.forEach.call(wrap.querySelectorAll('.kp-bp__tile'), function (tileEl) {
        var hit = !q || tileEl.getAttribute('data-name').indexOf(q) > -1;
        tileEl.hidden = !hit || (!q && count >= s.shown);
        if (hit) count++;
      });
      var more = wrap.querySelector('.kp-bp__more');
      if (more) more.hidden = !!q;
      fillTiles();
    });

    box.addEventListener('click', function (event) {
      var t = event.target.closest ? event.target.closest('button') : null;
      if (!t || !box.contains(t)) return;

      if (t.hasAttribute('data-kp-bb-type')) {
        state.chosenType = t.getAttribute('data-kp-bb-type');
        view.slide = 0;
        Array.prototype.forEach.call(box.querySelectorAll('[data-kp-bb-type]'), function (c) {
          c.classList.toggle('is-selected', c === t);
          c.setAttribute('aria-pressed', c === t ? 'true' : 'false');
        });
        refresh('type');
        return;
      }

      if (t.hasAttribute('data-kp-bb-extra')) {
        var kind = t.getAttribute('data-kp-bb-extra');
        var at = state.extras.indexOf(kind);
        if (at > -1) state.extras.splice(at, 1);
        else state.extras.push(kind);
        draw('extras');
        loadLists().then(matchAll).then(function () { return refresh('extras'); });
        return;
      }

      if (t.hasAttribute('data-kp-bb-open')) {
        var key0 = t.getAttribute('data-kp-bb-open');
        var s = state.slots[key0];
        if (s) s.open = !s.open;
        view.slide = slideOf(key0);
        draw(key0);
        return;
      }

      if (t.hasAttribute('data-kp-bb-version')) {
        var keyV = t.getAttribute('data-kp-bb-version');
        var sV = state.slots[keyV];
        if (sV && sV.variants) {
          sV.variant = sV.variants.filter(function (v) { return v.id === t.getAttribute('data-id'); })[0] || sV.variant;
          sV.open = false;
        }
        view.slide = slideOf(keyV);
        draw(keyV);
        return;
      }

      if (t.hasAttribute('data-kp-bb-more')) {
        var s2 = state.slots[t.getAttribute('data-kp-bb-more')];
        if (s2) s2.shown += PAGE_SIZE * 2;
        var keyM = t.getAttribute('data-kp-bb-more');
        var beforeM = rowTop(keyM);
        drawBox();
        var afterM = rowTop(keyM);
        if (beforeM !== null && afterM !== null) window.scrollTo(0, window.scrollY + (afterM - beforeM));
        return;
      }

      if (t.hasAttribute('data-kp-bb-pick')) {
        var key = t.getAttribute('data-kp-bb-pick');
        var entry = slotList().filter(function (e) { return e.key === key; })[0];
        var list = entry && listMap[entry.kind];
        var product = list && list.filter(function (p) { return p.handle === t.getAttribute('data-handle'); })[0];
        if (!entry || !product) return;
        var sl = slot(key, entry.kind);
        sl.open = false;
        sl.query = '';
        var isAnchor = key === anchorKey();
        if (!isAnchor) sl.matched = state.slots[anchorKey()] && state.slots[anchorKey()].product && designKey(product.title) === designKey(state.slots[anchorKey()].product.title);
        view.slide = slideOf(key);
        // Tick the tile at once; the box is redrawn once, when the new design is ready.
        Array.prototype.forEach.call(t.parentNode.querySelectorAll('.kp-bp__tile'), function (x) {
          x.classList.toggle('is-selected', x === t);
          x.setAttribute('aria-pressed', x === t ? 'true' : 'false');
        });
        setProduct(entry, product, !isAnchor).then(function () {
          return isAnchor ? matchAll() : null;
        }).then(function () {
          draw(key);
          settle(key);
        });
        return;
      }

      if (t.hasAttribute('data-kp-bb-add')) add();
    });

    // ---- Adding to the cart ----

    function add() {
      var why = ready();
      if (why || state.busy) {
        if (why) {
          var missing = lines().filter(function (l) { return !l.s.product || !l.s.variant; })[0];
          if (bundle.phone && !state.model) {
            var sel = box.querySelector('[data-kp-bb-model]');
            if (sel) { sel.scrollIntoView({ behavior: 'smooth', block: 'center' }); sel.focus(); }
          } else if (missing) goTo(missing.entry.key);
        }
        return;
      }

      var all = lines();
      var anchor = state.slots[anchorKey()];
      var mark = numberOf(anchor.product.id) + '#' + bundle.offer;
      var items = all.map(function (line) {
        var props = {};
        props[PROPERTY] = mark;
        return { id: parseInt(numberOf(line.s.variant.id), 10), quantity: 1, properties: props };
      });
      var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      state.busy = true;
      drawBox();

      fetch(rootUrl + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (response) {
        if (!response.ok) throw new Error('add');
        return fetch(rootUrl + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
      }).then(function (cart) {
        var codes = ((cart && cart.discount_codes) || []).map(function (c) { return c.code; });
        if (codes.indexOf(bundle.code) < 0) codes.push(bundle.code);
        return fetch(rootUrl + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: codes.join(',') })
        }).catch(function () {});
      }).then(function () {
        state.busy = false;
        state.added = true;
        drawBox();
        try { document.dispatchEvent(new CustomEvent('kp:cart.change')); } catch (e) {}
        try {
          var R = window.Rebuy;
          var p = R && R.Cart && typeof R.Cart.fetchCart === 'function' ? R.Cart.fetchCart() : null;
          Promise.resolve(p).then(function () {
            if (R && R.SmartCart && typeof R.SmartCart.show === 'function') R.SmartCart.show();
            else window.location.href = rootUrl + 'cart';
          });
        } catch (e) {}
        window.setTimeout(function () { state.added = false; drawBox(); }, 2500);
      }).catch(function () {
        state.busy = false;
        drawBox();
        var b = box.querySelector('.kp-bp__add');
        if (b) b.textContent = 'Sorry, that didn’t work. Try again';
      });
    }

    // ---- Start ----

    // The section puts the first design in the page already (data-seed...): its photo
    // shows at once, and it is picked straight away without waiting for the list of
    // every design (hundreds of phone cases, a few seconds), which loads in the
    // background for the design grid.
    var seedHandle = root.getAttribute('data-seed') || '';
    var seedImage = root.getAttribute('data-seed-image') || '';
    var seedProduct = seedHandle && root.getAttribute('data-seed-id') ? {
      id: 'gid://shopify/Product/' + root.getAttribute('data-seed-id'),
      handle: seedHandle,
      title: root.getAttribute('data-seed-title') || seedHandle,
      availableForSale: true,
      featuredImage: { url: root.getAttribute('data-seed-thumb') || seedImage },
      big: { url: seedImage, seed: true }
    } : null;

    if (!galleryEl.querySelector('img')) draw();
    else drawBox();

    var aKey0 = anchorKey();
    var aEntry0 = slotList().filter(function (e) { return e.key === aKey0; })[0];
    if (seedProduct && aEntry0) {
      var picked = setProduct(aEntry0, seedProduct, false);
      var matched = matchAll();
      draw();
      Promise.all([picked, matched]).then(function () { draw(); });
      // The full lists, for the design grids, when they come.
      loadLists().then(function () { draw(); });
    } else {
      loadLists().then(function () {
        // Open like a product page: a design is already picked (and everything else
        // matched to it), so the photos and price show straight away.
        var aKey = anchorKey();
        var aEntry = slotList().filter(function (e) { return e.key === aKey; })[0];
        var aSlot = aEntry && slot(aEntry.key, aEntry.kind);
        var list = aEntry && listMap[aEntry.kind];
        var first = list && list[0];
        if (aSlot && !aSlot.product && first) {
          var p1 = setProduct(aEntry, first, false);
          var p2 = matchAll();
          draw();
          return Promise.all([p1, p2]).then(function () { draw(); });
        }
        draw();
        return state.model ? refresh() : null;
      });
    }
  }

  function startAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-kp-bundle-builder]'), start);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startAll);
  else startAll();
  document.addEventListener('shopify:section:load', startAll);
})();
